const ACTIONS = {
    GET_DATA_NEWS_SUCCESS: 'GET_DATA_NEWS_SUCCESS',
    GET_DATA_NEWS_ERROR: 'GET_DATA_NEWS_ERROR',
    READ_DATA_NEWS_SUCCESS: 'READ_DATA_NEWS_SUCCESS',
    READ_DATA_NEWS_ERROR: 'READ_DATA_NEWS_ERROR',
};

const data = [
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: '内容テキスト内容テキスト内容テキスト内容テキ...',
            status: '納品済',
            dot: true
        }
    }
]

export default (state = {
    data
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_NEWS_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.READ_DATA_NEWS_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_NEWS_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};